module.exports = __webpack_public_path__ + "media/images/area/feature/banner/en/sp/en_tohoku-d56becc4615c30172eb258c67bd6ab77.png";